<template>
	<div
		v-if="showing"
		class="add-to-homescreen"
	>
		<div class="inner">
			Install this webapp on your iPhone by tapping <ShareIconComponent /> and then "Add to Home Screen". You must be using Safari.
			<button
				class="close"
				@click="close"
			>
				&times;
			</button>
		</div>
	</div>
</template>

<script lang="ts">
import { IsiOs } from '@/helpers';
import { defineComponent } from 'vue';
import ShareIconComponent from '@/images/share-apple.svg?component';

export default defineComponent({
	components: { ShareIconComponent },
	props: {
		disableTimer: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showing: false,
			timeout: 0,
		};
	},
	mounted() {
		if (!IsiOs()) {
			return;
		}

		// https://stackoverflow.com/questions/41742390/javascript-to-check-if-pwa-or-mobile-web
		if (window.matchMedia('(display-mode: standalone)').matches) {
			return;
		}

		const hasAlreadyShown = window.localStorage.getItem('rs.partnerportal.addToHomeScreen');
		if (hasAlreadyShown) {
			return;
		}

		if (!this.disableTimer) {
			this.timeout = window.setTimeout(() => {
				window.localStorage.setItem('rs.partnerportal.addToHomeScreen', 'true');
				this.open();
			}, 10 * 1000);
		}
	},
	unmounted() {
		window.clearTimeout(this.timeout);
	},
	methods: {
		open() {
			this.showing = true;
		},
		close() {
			this.showing = false;
		},
	},
});
</script>

<style scoped lang="scss">
.add-to-homescreen {
	display: flex;
	position: fixed;
	right: 0;
	bottom: 30px;
	left: 0;
	justify-content: center;
	z-index: 99999999;

	.inner {
		position: relative;
		box-shadow: rgb(0 0 0 / 24%) 0 3px 8px;
		border-radius: var(--rs-border-radius);
		background-color: white;
		padding: var(--rs-layout-content-padding);
		max-width: 300px;

		svg {
			position: relative;
			top: 7px;
		}

		.close {
			display: flex;
			position: absolute;
			top: 0;
			right: 0;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
			font-size: 20px;
		}

		&::after {
			position: absolute;
			bottom: -30px;
			left: 50%;
			transform: translateX(-50%);
			filter: drop-shadow(2px 4px 2px rgb(0 0 0 / 24%));
			border-top: 30px solid white;
			border-right: 20px solid transparent;
			border-left: 20px solid transparent;
			width: 0;
			height: 0;
			content: '';
		}
	}
}
</style>
